export default "__VITE_ASSET__BWnujn61__"